const getOrdinalName = (number) => {
  const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'];
  return number > 0 && number <= 10 ? ordinals[number - 1] : number;
};

export default getOrdinalName;
